<template>
    <div class="task-list">
        <div class="title">
            <span class="text">{{ title }}</span>
            <span class="sub-text">{{ desc }}</span>
        </div>

        <div class="task-item-container">
            <task-item
                v-for="(task, index) in taskList"
                v-on="$listeners"
                :key="index"
                :task="task"
                :class="{ 'mt-30': index !== 0 }"
            ></task-item>
        </div>
    </div>
</template>

<script>
import TaskItem from './TaskItem';

export default {
    components: {
        TaskItem
    },
    props: {
        taskInfo: {
            type: Object
        }
    },
    computed: {
        title() {
            return this.taskInfo.title || '';
        },
        desc() {
            return this.taskInfo.desc || '';
        },
        taskList() {
            return this.taskInfo.taskList || [];
        }
    }
};
</script>

<style lang="scss" scoped>
.task-list {
    .title {
        .text {
            font-weight: bold;
            font-size: 16px;
            color: #002a3c;
        }
        .sub-text {
            font-weight: bold;
            font-size: 12px;
            color: #9faab5;
            margin-left: 6px;
        }
    }
    .task-item-container {
        margin-top: 20px;
    }
}
.mt-30 {
    margin-top: 30px;
}
</style>